import React, { PureComponent } from "react";
import TextFormGroup from "../../common/form/TextFormGroup/TextFormGroup";
import StateFormGroup from "../../common/form/StateFormGroup/StateFormGroup";
import DatePickerFormGroup from "../../common/form/DatePickerFormGroup/DatePickerFormGroup";
import { defineMessages } from "react-intl";
import isEmpty from "assets/scripts/utils/isEmpty";
import styles from "./ProbateCaseFormGroups.module.less";
import { REQUIRED } from "assets/scripts/constants/FormMessages";
import getStateError from "assets/scripts/utils/getStateError";
import getMaxLengthError from "assets/scripts/utils/getMaxLengthError";
import moment from "moment";
const messages = defineMessages({
    caseNumberLabel: {
        id: "forms.probateCase.caseNumber.label",
        defaultMessage: "Case Number"
    },
    stateLabel: {
        id: "forms.probateCase.state.label",
        defaultMessage: "State"
    },
    countyLabel: {
        id: "forms.probateCase.county.label",
        defaultMessage: "County"
    },
    petitionDateLabel: {
        id: "forms.probateCase.petitionDate.label",
        defaultMessage: "Petition/File Date"
    },
    caseTypeLabel: {
        id: "forms.probateCase.caseType.label",
        defaultMessage: "Case Type"
    },
    dodLabel: {
        id: "forms.probateCase.dod.label",
        defaultMessage: "Date of Death"
    },
    dobLabel: {
        id: "forms.probateCase.dob.label",
        defaultMessage: "Date of Birth"
    },
    futureDateError: {
        id: "forms.probateCase.futureDateError",
        defaultMessage: "Cannot be in the future"
    }
});
export const EMPTY_PROBATE_CASE = {
    caseNumber: "",
    state: "",
    county: "",
    petitionDate: null,
    caseType: "",
    dod: null,
    dob: null
};
function isRequired(probateCase, forceRequired) {
    return forceRequired
        || !isEmpty(probateCase.caseNumber)
        || !isEmpty(probateCase.state)
        || !isEmpty(probateCase.county)
        || !isEmpty(probateCase.petitionDate);
}
function getRequiredError(value, required, maxLength) {
    let error = required && isEmpty(value) ? REQUIRED : null;
    if (error == null && maxLength != null) {
        error = getMaxLengthError(value, maxLength);
    }
    return error;
}
function getFutureDateError(value) {
    if (isEmpty(value)) {
        return null;
    }
    const date = moment(value);
    return date.isBefore(moment().startOf("day").add(1, "day"))
        ? null
        : messages.futureDateError;
}
export function getErrors(probateCase, forceRequired = false) {
    const required = isRequired(probateCase, forceRequired);
    const caseNumber = getRequiredError(probateCase.caseNumber, required, 100);
    const state = getStateError(probateCase.state, required);
    const county = getRequiredError(probateCase.county, required, 100);
    const petitionDate = getRequiredError(probateCase.petitionDate, required)
        || getFutureDateError(probateCase.petitionDate);
    const caseType = getMaxLengthError(probateCase.caseType, 100);
    const dod = getFutureDateError(probateCase.dod);
    const dob = getFutureDateError(probateCase.dob);
    return {
        caseNumber,
        state,
        county,
        petitionDate,
        caseType,
        dod,
        dob
    };
}
export default class ProbateCaseFormGroups extends PureComponent {
    constructor() {
        super(...arguments);
        this._handleCaseNumberChange = (caseNumber) => this._handleChange({ caseNumber });
        this._handleStateChange = (state) => this._handleChange({ state });
        this._handleCountyChange = (county) => this._handleChange({ county });
        this._handlePetitionDateChange = (petitionDate) => {
            this._handleChange({ petitionDate: petitionDate || null });
        };
        this._handleCaseTypeChange = (caseType) => this._handleChange({ caseType });
        this._handleDodChange = (dod) => this._handleChange({ dod: dod || null });
        this._handleDobChange = (dob) => this._handleChange({ dob: dob || null });
    }
    render() {
        const { props } = this;
        const { probateCase, errors } = props;
        const backendErrors = props.backendErrors || {};
        const prefix = props.namePrefix == null ? "" : `${props.namePrefix}_`;
        const required = isRequired(probateCase, !!props.forceRequired);
        return (<div>
				<TextFormGroup name={`${prefix}caseNumber`} label={messages.caseNumberLabel} value={probateCase.caseNumber} onChange={this._handleCaseNumberChange} error={errors.caseNumber} backendError={backendErrors.caseNumber} required={required}/>

				<StateFormGroup name={`${prefix}state`} className={styles.formGroupLeft} label={messages.stateLabel} value={probateCase.state} onChange={this._handleStateChange} error={errors.state} backendError={backendErrors.state} required={required} inputProps={{
            autoComplete: "address-level1"
        }}/>

				<TextFormGroup name={`${prefix}county`} className={styles.formGroupRight} label={messages.countyLabel} value={probateCase.county} onChange={this._handleCountyChange} error={errors.county} backendError={backendErrors.county} required={required}/>

				<DatePickerFormGroup name={`${prefix}petitionDate`} label={messages.petitionDateLabel} value={probateCase.petitionDate || ""} onChange={this._handlePetitionDateChange} error={errors.petitionDate} backendError={backendErrors.petitionDate} required={required}/>

				<TextFormGroup name={`${prefix}caseType`} label={messages.caseTypeLabel} value={probateCase.caseType} onChange={this._handleCaseTypeChange} error={errors.caseType} backendError={backendErrors.caseType}/>

				<DatePickerFormGroup name={`${prefix}dod`} className={styles.formGroupLeft} label={messages.dodLabel} value={probateCase.dod || ""} onChange={this._handleDodChange} error={errors.dod} backendError={backendErrors.dod}/>

				<DatePickerFormGroup name={`${prefix}dob`} className={styles.formGroupRight} label={messages.dobLabel} value={probateCase.dob || ""} onChange={this._handleDobChange} error={errors.dob} backendError={backendErrors.dob}/>
			</div>);
    }
    _handleChange(updates) {
        this.props.onChange({
            ...this.props.probateCase,
            ...updates
        });
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/ProbateCaseFormGroups/ProbateCaseFormGroups.tsx